// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1WOuC","colCheckbox":"styles_colCheckbox__vOANC"};